<template>
    <div class="notification-wrapper">
        <div class="notification-text">
            Материал создан исключительно в образовательных целях и предназначен только для специалистов здравоохранения. Любое совпадение с реальными пациентами случайно. Тактика лечения определяется лечащим врачом.
        </div>

        <AcceptCheckbox
        v-if="actualView.acceptCheckbox"  
        :isAccept=isAccept
        @changeAccept = changeAccept
        />

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import AcceptCheckbox from '@/components/game/AcceptCheckbox.vue'

export default {
    name: 'InfoNotification',
    data() {
      return {
        isAccept: false
      }
    },
    components: {
        AcceptCheckbox
    },
    computed: {
      ...mapGetters([
          "actualView"
      ]),
    },
    methods: {
      ...mapActions([
          "setAcceptCheckbox"
      ]),
      changeAccept() {
        this.isAccept = !this.isAccept
        this.setAcceptCheckbox(this.isAccept)
      }
    }
}
</script>

<style>
    
</style>
